/** Get the element ref from the URL */

import queryString from 'query-string'
import { useLocation } from 'react-router'
import { isString } from '@tunasong/models'

/**
 * The `?ref=<id>` of the current location: a comment to open in Chat, or a note to open in My
 * Notes (GH #1579). Read from the router so it follows client-side navigation, not only a full
 * page load.
 */
export const useElementRef = () => {
  const { search } = useLocation()
  const { ref } = queryString.parse(search)
  return isString(ref) ? ref : undefined
}
